import * as React from 'react'
import * as style from './index.module.css'

/**
 * PrivacyPolicy
 */
export const PrivacyPolicy = (): React.JSX.Element => {
  return (
    <>
      <h2>個人情報保護方針</h2>
      <br />
      <br />
      <div>
        <p className={style.text}>
          株式会社SOZO（以下「当社」といいます。）は、Web開発事業を行う企業として、個人情報を適切に取り扱うことの重要性を認識し、
          個人情報保護方針を定めております。
        </p>
        <p className={style.text}>
          当社の役員及び従業員が一体となってこれを遵守し、個人情報の保護及び個人の権利利益の保護に万全を尽くしてまいります。
        </p>
      </div>
      <br />
      <div>
        <p className={style.text}>
          1.個人情報（個人情報の保護に関する法律（平成15年法律第57号。以下「個人情報保護法」といいます。）
          第2条第1項に定義するところの「個人情報」を指します）を取得するにあたり、利用目的をできる限り特定し、その目的の達成に必要な限度で取得いたします。
        </p>
        <p className={style.text}>
          2.個人情報を本人から取得する場合には、当社名、個人情報保護管理者名及び連絡先、利用目的等をお知らせした上で、必要な範囲で取得いたします。
        </p>
        <p className={style.text}>
          3.個人情報の利用は、本人があらかじめ同意した利用目的の範囲内で行います。
          また、目的外利用を行わないため、必要な対策を講じる手順を確立し、実施いたします。
        </p>
        <p className={style.text}>
          4.当社は、保有する個人情報を適切な方法で管理し、本人の同意なしに第三者に開示・提供いたしません。
        </p>
        <p className={style.text}>
          5.当社は、保有する個人情報を利用目的に応じた必要な範囲内で、正確かつ最新の状態で管理し、個人情報の漏えい、滅失または毀損などのおそれに対して、合理的な安全対策を講じ、予防および是正に努めます。
        </p>
        <p className={style.text}>
          6.当社は、個人情報の処理を外部に委託する場合、漏えいや第三者への提供を行わないことを契約により義務づけ、委託先に対する適切な管理を実施いたします。
        </p>
        <p className={style.text}>
          7.当社は、個人情報の取扱いに関する法令、国が定める指針その他の規範を遵守いたします。
        </p>
        <p className={style.text}>
          8.個人情報保護マネジメントシステムを定め、これを定期的に見直し、継続的に改善いたします。
        </p>
      </div>
      <br />
      <br />
      <br />
      <div className={style.contact}>
        <p className={style.text}>制定日：2024年10月29日</p>
        <br />
        <br />
        <p className={style.text}>個人情報保護方針についてのお問合せ先</p>
        <p className={style.text}>株式会社SOZO　個人情報相談受付窓口</p>
        <br />
        <p className={style.text}>〒154-0012</p>
        <p className={style.text}>
          東京都世田谷区駒沢5丁目26-7 駒沢パークサイドテラスノース 1F
        </p>
      </div>
    </>
  )
}
